module.exports = __webpack_public_path__ + "media/images/area/feature/hokkaido/icon_arrow-91335e3a0c7b707c74fd7ee32af5004e.svg";